import axios from './axios';

export default {
  list: () => axios.get('/sites'),
  create: () => axios.post('/sites'),
  update: (id, payload) => axios.put(`/sites/${id}`, { site: payload }),
  delete: (id) => axios.delete(`/sites/${id}`),
};